import vars from "../_vars";
import { getCarCards } from "./modalRental";

export default function catalogContainer() {
  const catalogContainer = document.getElementById('catalogContainer')
  if (!catalogContainer) return

  var target = catalogContainer;

  const config = {
    childList: true,
  };

  const callback = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        console.log('A child node has been added or removed.');
        vars.carCards = getCarCards()
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(target, config);
}

// добавляю новую карточку для теста
// const catalogContainer= document.getElementById('catalogContainer')
// const article = document.createElement('article')
// article.classList.add('auto-block')
// article.dataset.idCar = '999'
// catalogContainer.prepend(article)
// article.innerHTML = `<div class="auto-block__img-block">
// <img class="auto-block__img" src="img/lamborghini-urus.webp" alt="">
// <img class="auto-block__img-alt" src="img/lamborghini-urus.webp" alt="">
// </div>
// <div class="auto-block__content">
// <p class="auto-block__title" data-name="LamboTEST">Mercedes-Benz S500</p>
// <ul class="list-reset auto-block__characteristics characteristics">
//   <li class="characteristics__item">
//     <p class="characteristics__item-name">Year:</p>
//     <i class="characteristics__item-decor"></i>
//     <p class="characteristics__item-value">2021</p>
//   </li>
//   <li class="characteristics__item">
//     <p class="characteristics__item-name">Engine:</p>
//     <i class="characteristics__item-decor"></i>
//     <p class="characteristics__item-value">550 HP</p>
//   </li>
//   <li class="characteristics__item">
//     <p class="characteristics__item-name">0-100 km/h:</p>
//     <i class="characteristics__item-decor"></i>
//     <p class="characteristics__item-value">4,5 sec</p>
//   </li>
//   <li class="characteristics__item">
//     <p class="characteristics__item-name">Seating:</p>
//     <i class="characteristics__item-decor"></i>
//     <p class="characteristics__item-value">5</p>
//   </li>
// </ul>
// <div class="auto-block__rent">
//   <div class="auto-block__rent-info">
//     <p class="auto-block__deposit" data-deposit="5000" data-deposit-usd="2500">5 000 AED/deposit</p>
//     <p class="auto-block__cost" data-price-id="1" data-days-min="1" data-days-max="2" data-price="4200" data-price-usd="299">4 200 AED/day</p>
//     <p class="auto-block__cost-usd">3 200 $/day</p>
//     <p class="cost-hidden" data-price-id="2" data-days-min="3" data-days-max="7" data-price="4000" data-price-usd="399"></p>
//     <p class="cost-hidden" data-price-id="3" data-days-min="8" data-days-max="29" data-price="3800" data-price-usd="499"></p>
//     <p class="cost-hidden" data-price-id="4" data-days-min="30" data-days-max="Infinity" data-price="2900" data-price-usd="599"></p>
//   </div>
//   <button class="auto-block__btn btn-reset js-order-car">Book</button>
// </div>
// </div>`